import React from 'react';
import { css } from '@emotion/core';
import { absoluteFull } from "../../Styles/utilities";
import { fontWeight } from "../../Styles/text";
import colors from "../../Styles/colors";

import CoveImage from "../../ShowPage/components/CoveImage";
import PassportLabel from "./PassportLabel";
import ResumePlayback from "./ResumePlayback";
import VideoDuration from "./VideoDuration";
import PBSImage from "./PBSImage";

const miniVideoLink = css`
 display: block; 
 & > .bounds-clip {
    position: relative;
    padding-bottom: 56.25%;
  }
 `;
const miniVideoWrapper = css`
  position: relative;
  width: 65%;
  display: inline-block;
  margin: 4px;
  white-space: initial;
  vertical-align: top;
  
  & .resume-trackbar {
    position: static;
    bottom: -6px;
  }
`;
const miniVideoImage = css` ${absoluteFull()} `;
const miniVideoInfo = css` ${absoluteFull()} `;
const miniVideoExp = css`
  padding: 2px 4px;
  background: rgba(0, 0, 0, 0.5);
  color: ${colors.coreColor2};
  text-align: right;
`;
const showTitle = css`
  margin: 4px 0;
  color: ${colors.coreColor2};
  font-size: 12px;
  text-transform: uppercase;
  font-weight: ${fontWeight.extrabold};
`;
const videoTitle = css`
  color: ${colors.coreColor2};
`;


const ONE_DAY = 60 * 60 * 24;
const EXPIRATION_TRIGGER = ONE_DAY * 7;

function time() {
  return Math.floor(Date.now() / 1000);
}

function getWindowKey(accessLevel) {
  switch(accessLevel) {
    case 0:
      return 'public';
    case 1:
      return 'all_members';
    case 2:
      return 'station_members';
    default:
      return '';
  }
}

function getWindow(accessLevel, video) {
  let windowKey = getWindowKey(accessLevel);
  return video.availabilities && video.availabilities[windowKey] || null;
}

function getExpiration(video) {
  let window = getWindow(video.minimum_access_level, video);
  return window && window.end || null;
}

function isExpiring(video) {
  let expiration = getExpiration(video);
  let now = time();

  return expiration && (expiration - now) < EXPIRATION_TRIGGER;
}

function humanExpiration(video) {
  if (isExpiring(video)) {
    let expiration = getExpiration(video);
    let now = time();

    return Math.ceil((expiration - now) / ONE_DAY);
  }

  return null;
}

function dayIndicator(count) {
  return count === 1 ? 'Day' : 'Days';
}

/**
 * Filters out extraneous title parts that are commonly seen
 *
 * @param {string} title
 * @returns {string}
 */
function filterTitle(title) {
  title = title.replace(/^FULL EPISODE: /, '');
  title = title.replace(/ - PBS NewsHour full episode$/i, '');

  return title;
}

export class MiniVideoPlaceholder extends React.PureComponent<any> {
  render() {
    return <div css={miniVideoWrapper}>
      <div css={miniVideoLink}>
        <div className="bounds-clip" />
      </div>
    </div>;
  }
}

export default class MiniVideo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      progress: 0
    };
  }

  render() {
    let { show, full_length } = this.props;
    let expiresIn = humanExpiration(full_length);

    return <div css={miniVideoWrapper}>
        <a css={miniVideoLink} href={full_length.default_url} aria-label={`${show.title} - ${full_length.title}`}>
          <div className="bounds-clip">
            <PBSImage
              alt={`${show.title} - ${full_length.title}`}
              aspectRatio={0.5625}
              emoCSS={miniVideoImage}
              imageSizes={{min: 100, max: 700, step: 150}}
              sizes={[
                {breakpoint: '1401px', width: '34vw'},
                {breakpoint: '1101px', width: '40vw'},
                {breakpoint: '801px', width: '50vw'},
                {breakpoint: '501px', width: '66vw'},
                {breakpoint: '0', width: '100vw'}]}
              url={full_length.mezzanine} />
            <div css={miniVideoInfo}>
              { full_length.is_passport && <PassportLabel/> }
              {
                expiresIn &&
                <div css={miniVideoExp}>
                    <span className="expiration-text">
                      <i className="far fa-clock"/> {expiresIn} {dayIndicator(expiresIn)}
                    </span>
                </div>
              }
              <VideoDuration {...this.props} />
            </div>
          </div>
          <ResumePlayback progress={this.state.progress} background={this.state.progress > 0 ? undefined : 'transparent'} />
          <div className="mini-video-title">
            <div css={showTitle} className="body-normal">{show.title}</div>
            {
              show.title.toLowerCase() !== filterTitle(full_length.title).toLowerCase() &&
              <div css={videoTitle} className="body-small">{filterTitle(full_length.title)}</div>
            }
          </div>
        </a>
    </div>;
  }
}